import { render, staticRenderFns } from "./turnoverStatistics.vue?vue&type=template&id=e8062c06&scoped=true&"
import script from "./turnoverStatistics.vue?vue&type=script&lang=ts&"
export * from "./turnoverStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./turnoverStatistics.vue?vue&type=style&index=0&id=e8062c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8062c06",
  null
  
)

export default component.exports